"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  usePreferences: true,
  UsePreferences: true,
  PreferenceSection: true,
  useTransport: true
};
Object.defineProperty(exports, "usePreferences", {
  enumerable: true,
  get: function get() {
    return _usePreferences["default"];
  }
});
Object.defineProperty(exports, "UsePreferences", {
  enumerable: true,
  get: function get() {
    return _usePreferences.UsePreferences;
  }
});
Object.defineProperty(exports, "PreferenceSection", {
  enumerable: true,
  get: function get() {
    return _types.PreferenceSection;
  }
});
Object.defineProperty(exports, "useTransport", {
  enumerable: true,
  get: function get() {
    return _useTransport["default"];
  }
});

var _inbox = require("./inbox");

Object.keys(_inbox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _inbox[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _inbox[key];
    }
  });
});

var _usePreferences = _interopRequireWildcard(require("./preferences/use-preferences"));

var _types = require("./preferences/types");

var _useTransport = _interopRequireDefault(require("./use-transport"));